import '../../assets/css/main.css';
import premier_cover_title from '../../assets/img/premier_concerto_book_cover_front.jpg';

interface WorksDetailProps {
  id: number;
  onTileClick: (id: number | null) => void;
}

function WorksDetail({ id, onTileClick }: WorksDetailProps) {

    return (
        <>
            <div className="container">
                <div>
                    <span onClick={() => onTileClick(null)}>&lt;- Back</span>
                </div>
                <div className="work-details-container">
                  <div className="work-details-box">
                    <img src={premier_cover_title} className="premier-image" alt="Premier Concerto in A minor cover art" />
                  </div>
                  <div className="work-details-box" style={{background: "white"}}>
                    <div style={{paddingTop: "50px", paddingBottom: "20px"}}>
                        <h2>
                            <b>Premier Concerto in A minor</b>
                        </h2>
                        <h5>Violin Concerto in the Baroque Tradition</h5>
                        <h5>For Principal Violin, Principal Violoncello, String Orchestra, and Cembalo</h5>
                    </div>
                    <div>
                        <p style={{textAlign: "left"}}>
                            <span style={{textAlign: "left"}}>
                                Modern implementation of a Baroque-style Violin Concerto for String Orchestra and Cembalo (Harpsichord). This work is part of a larger collection of works, "The Premier Suite", exploring the use a central musical theme introduced in this compositional work, a collection which is currently in progress.
                                <br />
                                <br />
                                <br />
                                Includes full score. Customers that purchase the score can be provided with the e-book extracts of the parts by contacting the author.
                                <br />
                                <br />
                                <br />
                                Approximately 15 minutes in length.
                                <br />
                                <br />
                                <a href="https://www.lulu.com/shop/jose-bravo-tejeda/premier-concerto-in-a-minor/paperback/product-65rzkqq.html?q=premier+concerto+in+a+minor&page=1&pageSize=4" target="_blank" rel="noreferrer" style={{textAlign: "center"}}>Click here to purchase at Lulu.com</a>
                                <br />
                                <br />
                                <a href="https://www.youtube.com/watch?v=i2FVXGA05fo" target="_blank" rel="noreferrer" style={{textAlign: "center"}}>Click here listen to a recording of this on YouTube</a>
                            </span>
                        </p>
                    </div>
                  </div>
                </div>
            </div>
        </>
    )
}

export default WorksDetail;